import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { frameTimecode } from '../../domain/frame-timecode';
import type { MarkerTime } from './timeline-scale';

export function TimelineCluster({ button, items, onSelect, onClose }: {
  button: HTMLButtonElement; items: MarkerTime[]; onSelect: (id: string) => void; onClose: () => void;
}) {
  const host = useRef<HTMLDivElement>(null);
  useEffect(() => {
    host.current?.querySelector('button')?.focus();
    const outside = (event: Event) => { if (!host.current?.contains(event.target as Node) && !button.contains(event.target as Node)) onClose(); };
    document.addEventListener('pointerdown', outside, true);
    return () => document.removeEventListener('pointerdown', outside, true);
  }, [button]);
  const rect = button.getBoundingClientRect();
  return createPortal(<div ref={host} className="timeline-cluster" role="group" aria-label="Nearby keyframes"
    data-theme={button.closest('[data-theme]')?.getAttribute('data-theme')}
    style={{ left: Math.max(8, Math.min(innerWidth - 258, rect.left - 100)), top: Math.max(8, rect.top - items.length * 44 - 12) }}
    onKeyDown={event => {
      event.stopPropagation();
      if (event.key === 'Escape') { event.preventDefault(); onClose(); button.focus(); }
    }}>
    {items.map(item => <button type="button" key={item.id} onClick={() => { onSelect(item.id); onClose(); }}>Keyframe {item.number} · {frameTimecode(item.frame)}</button>)}
  </div>, button.closest('.workbench') ?? document.body);
}
